// extracted by mini-css-extract-plugin
export default {"delivered-package":"achievement_delivered-package__0-27+","divider":"achievement_divider__HeBN7"};